<header class="modal-header bg-white border-bottom-0">
  <h5 class="modal-title" id="modal-basic-title font-weight-bold">
    {{ modelo.titulo }}
  </h5>
  <button type="button" class="close" (click)="onDismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</header>
<section class="modal-body">
  <ng-content></ng-content>
</section>
